import {
  getRoot,
  IAnyModelType,
  types,
  Instance,
  SnapshotIn,
  SnapshotOut,
  onAction,
} from 'mobx-state-tree';
import { modelWithCRUD } from '../utils/modelWithCRUD';
import { RootModelType } from '../Root';
import { CompanyReference } from './CompanyStore';
import { ContactReference } from './ContactStore';

export const Relation = types.model('Relation', {
  id: types.union(types.identifier, types.identifierNumber),
  title: types.maybeNull(types.string),
  company: types.late(() => CompanyReference),
  contact: types.late(() => ContactReference),
});

export const RelationStore = modelWithCRUD('relations', Relation).actions(
  (self) => ({
    afterCreate() {
      onAction(self, (call) => {
        if (call.name === 'invalidateCaches') {
          // Invalidate company store and contact store caches
          const root = getRoot(self) as RootModelType;
          root.contactStore.invalidateCaches();
          root.companyStore.invalidateCaches();
        }
      });
    },
  })
);

export const RelationReference = types.reference(
  types.late((): IAnyModelType => Relation),
  {
    get(identifier, parent): any {
      return (getRoot(parent!) as RootModelType).relationStore.getItemNaive(
        identifier
      );
    },
    set(value) {
      return value.id;
    },
  }
);

export interface IRelation extends Instance<typeof Relation> {}
export interface IRelationSnapshotIn extends SnapshotIn<typeof Relation> {}
export interface IRelationSnapshotOut extends SnapshotOut<typeof Relation> {}
